module.exports = __webpack_public_path__ + "img/25.ce0cb735.jpg";